

export const multiTranslate = {
  data() {
    return{
      multiBrandZH:{
        ACIoTMP:"ITS亚太物联网管理平台",
        ACDMap:"空压机分布图",
        totalShipment:"已发货",
        registration:"空压机注册率",
        online:"在线率",
        warning:"告警数",
        trip:"故障数",
        utilization:"空压机利用率",
        offline:"离线率",
        IotInsight:"IoT洞察",
        rate:"比例：",
        count:"数量：",
        UtilizationRate:"利用率",
        lastmonth:"上月",
        ACIoTSMP:"ITS亚太空压机站房监控平台",
        projectList:"项目列表",
        AvgPressureRange:"平均压力分布",
        AvgFlowRange:"平均流量分布",
        sumFlowByDay:"总瞬时流量",
        sumPowerByDay:"总瞬时功率",
        electricitySaving:"电量节省",
        sumSavingMoney:"电费节省",
        flowTrend:"瞬时流量",
        pressureTrend:"压力",
        powerTrend:"瞬时功率",
        dewPointTrend:"瞬时露点",
        specificPowerRatioTrend:"比功率",
        sumFlow:"累计流量",
        sumPower:"累计功率",
        sumBattery:"累计电量",
        avgPressure:"平均压力",
        avgDewPoint:"平均露点",
        avgSpecificPowerRatio:"比功率",
        flowPowerRatioTrend:"单耗",
        sumFlowPowerRatio:"单耗",
        threeTrend: "单耗-流量-电量",
      },
      multiBrandEn:{
        ACIoTMP:"ITS AP IoT Management Platform",
        ACDMap:"Air Compressor Distribution Map",
        totalShipment:"Total Shipment",
        registration:"Registration",
        online:"Online",
        warning:"Warning",
        trip:"Trip",
        utilization:"Utilization",
        offline:"Offline",
        IotInsight:"IoT Insight",
        rate:"Rate:",
        count:"Count:",
        UtilizationRate:" Utilization Rate",
        lastmonth:"Last Month",
        ACIoTSMP:"ITS AP Compressor Station Monitor Platform",
        projectList:"Project List",
        AvgPressureRange:"Average Pressure Range",
        AvgFlowRange:"Average Flow Range",
        sumFlowByDay:"Total Flow Rate",
        sumPowerByDay:"Total Power",
        electricitySaving:"Total Electricity Saving",
        sumSavingMoney:"Total Money Saving",
        flowTrend:"Flow",
        pressureTrend:"Pressure",
        powerTrend:"Power",
        dewPointTrend:"Dew Point",
        specificPowerRatioTrend:"Specific Power Ratio",
        flowPowerRatioTrend:"Specific Energy Consumption‌",
        sumFlow:"Total Flow",
        sumFlow:"Total Flow",
        sumPower:"Total Power Dissipation",
        sumBattery:"Total Electricity",
        avgPressure:"Average Pressure",
        avgDewPoint:"Average Dewpoint",
        avgSpecificPowerRatio:"Specific Power Ratio",
        sumFlowPowerRatio:"Specific Energy Consumption‌",
        threeTrend:"Specific Energy Consumption‌ - Flow - Power",
      }
    }
  },
  methods:{
    
  }
}